import { supabase } from '@/integrations/supabase/client';
import { LeadStatus } from '@/types/leads.types';
import { toast } from 'sonner';

export const useUpdateLead = () => {
  const updateLeadStatus = async (id: string, status: LeadStatus, lead: { 
    name: string; 
    email: string; 
    practice_type: string; 
    status: LeadStatus;
  }) => {
    const oldStatus = lead.status;
    
    // Don't send notification if status hasn't changed
    if (oldStatus === status) {
      return true;
    }

    const updates: { status: LeadStatus; last_contacted_at?: string } = { status };
    
    // Set last_contacted_at when changing status from 'new'
    if (status !== 'new') {
      updates.last_contacted_at = new Date().toISOString();
    }

    const { error } = await supabase
      .from('checklist_leads')
      .update(updates)
      .eq('id', id);

    if (error) {
      console.error('Error updating lead status:', error);
      toast.error('Fehler beim Aktualisieren des Status');
      return false;
    }

    // Send email notification about status change
    try {
      const { error: emailError } = await supabase.functions.invoke('send-lead-status-change', {
        body: {
          leadId: id,
          leadName: lead.name,
          leadEmail: lead.email,
          practiceType: lead.practice_type,
          oldStatus,
          newStatus: status,
        }
      });

      if (emailError) {
        console.error('Error sending status change notification:', emailError);
        // Don't fail the whole operation if email fails
      }
    } catch (emailError) {
      console.error('Error invoking status change notification:', emailError);
      // Don't fail the whole operation if email fails
    }

    toast.success('Status erfolgreich aktualisiert');
    return true;
  };

  const updateLeadNotes = async (id: string, notes: string) => {
    const { error } = await supabase
      .from('checklist_leads')
      .update({ notes })
      .eq('id', id);

    if (error) {
      console.error('Error updating lead notes:', error);
      toast.error('Fehler beim Speichern der Notizen');
      return false;
    }

    toast.success('Notizen gespeichert');
    return true;
  };

  return { updateLeadStatus, updateLeadNotes };
};
